import React, { DetailedHTMLProps, forwardRef, InputHTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './Input.module.scss';

export interface IInputProps
    extends Omit<
        DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
        'ref' | 'prefix' | 'size'
    > {
    size?: 'small' | 'medium';
    prefix?: React.ReactNode;
    suffix?: React.ReactNode;
    suffixSize?: 'compact' | 'wide';
    error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, IInputProps>(
    ({ className, prefix, suffix, suffixSize = 'compact', error, type, onChange, size = 'medium', ...props }, ref) => {
        return (
            <div className={classNames(styles.inputWrapper, styles[`size-${size}`])}>
                {prefix && <div className={styles.startIcon}>{prefix}</div>}
                <input
                    ref={ref}
                    className={classNames(
                        styles.input,
                        {
                            [styles.error]: !!error,
                            [styles.withPrefix]: !!prefix,
                            [styles.withSuffix]: !!suffix,
                        },
                        styles[`suffix-${suffixSize}`],
                        className,
                    )}
                    // Number input should be type text to allow thousand separator and localization
                    type={type === 'number' ? 'text' : type}
                    onChange={(e) => {
                        onChange?.(e);
                    }}
                    {...props}
                />
                {suffix && <div className={styles.endIcon}>{suffix}</div>}
            </div>
        );
    },
);
